import {Order, OrderItem} from 'aigens-ng-core';
import {OrderStatusPreKioskPage} from '../order-status-prekiosk/order-status-prekiosk';
import {MobileBasePage} from '../../../core/base/mobile-base-page';
import {Component, Injector, OnInit} from '@angular/core';
import {getDateStringLabel, timeStringLabel} from '../../../shared/utilities/checkFormatTool';
import {preloaderFinished} from '../../../../preloader';

/*
  Generated class for the ByodSummary page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-multi-order-history',
    templateUrl: 'multi-order-history.html',
    styleUrls: ['multi-order-history.scss']
})
export class MultiOrderHistoryPage extends MobileBasePage implements OnInit {

    orders: Order[];
    listExpand: {} = {};
    loadingTime: string;
    session: string;
    isIsolate: boolean;
    noFirebase = false;
    brandId: any;
    constructor(injector: Injector) {

        super(injector);
        this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + this.currentTimeString();
        this.session = this.getNavParams('sessionId');
        if (!this.session) {
            this.session = this.orderService.session;
        } else if (!this.orderService.session) {
            this.orderService.session = this.session;
        }
        let locale = this.getNavParams('locale');
        console.log(this.t.getLangs());
        console.log('input locale', locale);
        if (locale && this.t.currentLang !== locale) {
            this.t.use(locale).subscribe(data => {
                this.getOrders();
            });
        } else {
            this.getOrders();
        }

        this.configService.getPreference('paymentInfo').then((info) => {
            console.log('paymentInfo', info);
            if (info != null) {

                const orderId = info['orderId'];
                const paymentId = info['paymentId'];
                const lang = info['lang'];
                const hideHistory = info['hideHistory'];
                if (orderId && paymentId) {

                }
                if (lang && this.t.currentLang !== lang) {
                    this.t.use(lang);
                    this.configService.setLocale(lang);
                }

                if (hideHistory != null) {

                }
            }
            this.configService.putPreference('paymentInfo', null);
        });
    }

    ngOnInit() {

        super.ngOnInit();
        this.isIsolate = this.navigationService.getRootPageUrl().indexOf('history') !== -1;
        if (!this.isIsolate) {
            preloaderFinished();
        }

    }

    public pageName(): string {
        return '/multi-order-history';
    }

    handleFirebaseOrderStatus() {

        let str = null;
        let hasFirebase = true;
        for (let order of this.orders) {
            if (order && order['statusUrl']) {
                str = order['statusUrl'].toString();
                // prd aigensstoreapp.firebaseapp.com
                let indexOfUpdate = str.indexOf('update');
                let res = str.slice(indexOfUpdate, str.length - 5);
                // let lastIndex = res.lastIndexOf('/');
                // var res2 = res.slice(0, lastIndex + 1);
                // console.log('resres', res2);


                if (order && str) {
                    this.monitoringService.listenOrderStatus2(res, (current) => {

                    }, (update) => {
                        console.log('update detected', update);

                        if (update) {
                            order.status = update['status'];
                            order.callNo = update['callNo'];
                        }


                    }, () => {
                    });
                }
            } else {
                hasFirebase = false;
            }
        }
        this.noFirebase = !hasFirebase;

        // flag control
        // if (this.systemConfigService.showOrderQueue) {
        //     this.checkFirebaseStoreOrders();
        // }
    }

    getOrders(refresher?): void {

        const deviceId = this.sessionService.getDeviceId();

        console.log('deviceId', deviceId);
        this.loading(true);
        this.orderService.getOrders(this.session).subscribe(
            orders => {
                this.loading(false);
                if (refresher) {
                    refresher.complete();
                }
                this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + this.currentTimeString();
                // this.orders = this.sortingOrder(orders);
                this.orders = orders;
                this.handleFirebaseOrderStatus();
                console.log(orders);
                if (this.orders && this.orders.length > 0) {
                    this.orderService.store = this.orders[0].store;
                    this.brandId = this.orders[0].brandId;
                        this.orders.forEach(order => {
                        if (this.listExpand[order.id] === null) {
                            this.listExpand[order.id] = false;
                        }

                        if (order.orderitems) {
                            order.orderitems.forEach(oi => {
                                // oi.makeFlatItems();
                                OrderItem.flattenItems(oi);
                            });
                        }
                        if (order.pickup) {
                            order['pickupTimeLabel'] = timeStringLabel(order.pickup);

                        }
                    });
                    /*if(this.orders.length === 1){
                        this.listExpand[orders[0].id] = true;
                    }*/
                    if (this.orders[0].status !== 'completed') {
                        this.listExpand[this.orders[0].id] = true;
                    }
                }
            },
            err => {
                this.loading(false);
                if (refresher) {
                    refresher.complete();
                } else {
                    this.showError(err);
                }
                this.loadingTime = getDateStringLabel(new Date().getTime()) + ' ' + this.currentTimeString();
                console.log(err);

            },
            () => {
                preloaderFinished();
                this.loading(false);
            }
        );

    }

    orderClicked(order: Order) {

        if (order.type === 'prekiosk') {

            this.pushByName('OrderStatusPreKioskPage', {order: order});
        }
    }

    ionViewWillLeave() {
        super.ionViewWillLeave();
        this.monitoringService.unlistenAll();
    }

    doRefresh(refresher?) {
        this.getOrders(refresher);
    }

    getUIRefreshInterval(): number {
        return 10000;
    }

    onRefreshUI() {
        // console.log('refresh ui');
        // this.doRefresh();
    }

    // TO-DO expand only that list
    clickToExpand(index: string) {
        this.listExpand[index] = !this.listExpand[index];
    }

    currentTimeString(): string {
        return timeStringLabel(null, true);
    }

    sortingOrder(orders: Order[]): Order[] {
        let tmp: Order[] = [];
        const ready: Order[] = [];
        const received: Order[] = [];
        const paid: Order[] = [];
        const completed: Order[] = [];
        const pending: Order[] = [];
        const cancelled: Order[] = [];

        orders.forEach((order) => {
            // need a flag
            if (order.status === 'failed' && order.brandId === 5753217711341568) {
                order.status = 'paid';
            }
            // need a flag
            if (order.status === 'ready' && order.brandId === 5753217711341568) {
                order.status = 'paid';
            }

            if (order.status === 'ready') {
                ready.push(order);
            } else if (order.status === 'received') {
                received.push(order);
            } else if (order.status === 'paid') {
                paid.push(order);
            } else if (order.status === 'completed') {
                completed.push(order);
            } else if (order.status === 'pending') {
                pending.push(order);
            } else if (order.status === 'cancelled' && order.brandId === 5753217711341568) {
                cancelled.push(order);
            }
        });
        if (ready.length > 0) {
            tmp = tmp.concat(ready);
        }
        if (received.length > 0) {
            tmp = tmp.concat(received);
        }
        if (paid.length > 0) {
            tmp = tmp.concat(paid);
        }
        if (pending.length > 0) {
            tmp = tmp.concat(pending);
        }
        if (completed.length > 0) {
            tmp = tmp.concat(completed);
        }
        if (cancelled.length > 0) {
            tmp = tmp.concat(cancelled);
        }

        return tmp;
    }

    isSet(oi: OrderItem) {
        return OrderItem.isSet(oi);
    }

}
